export const parseCalendarDate = (value: unknown): string | undefined => {
	if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return undefined;
	const date = new Date(`${value}T00:00:00Z`);
	return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value ? value : undefined;
};

export const calendarDateFromHash = (hash: string, companyHotelId: number): string | undefined => {
	const params = new URLSearchParams(hash.replace(/^#/, ''));
	if (params.getAll('statDate').length !== 1 || params.getAll('companyHotelId').length !== 1) return undefined;
	if (Number(params.get('companyHotelId')) !== companyHotelId) return undefined;
	return parseCalendarDate(params.get('statDate'));
};

export const isCalendarSnapshotOutdated = (statDate: string, updatedAt: string | null | undefined, now = Date.now()): boolean => {
	if (!parseCalendarDate(statDate) || !updatedAt || statDate <= new Date(now).toISOString().slice(0, 10)) return false;
	const utcTimestamp = /(?:Z|[+-]\d{2}:?\d{2})$/.test(updatedAt) ? updatedAt : `${updatedAt}Z`;
	const updated = Date.parse(utcTimestamp);
	return Number.isFinite(updated) && now - updated > 72 * 60 * 60 * 1000;
};
